import type { PlaceType } from '../types';

/**
 * Venue glyphs, drawn as inline SVG paths rather than emoji.
 *
 * v2 used emoji throughout. They render differently on every platform, cannot be
 * recoloured to match a marker's trust state, and read as clip-art at 34px. These
 * are monochrome and inherit `currentColor`, so a pin's colour can carry the
 * trust signal while the glyph carries the venue type.
 */
const PATHS: Record<PlaceType, string> = {
    // fork + knife
    restaurant: 'M6 2v7a2 2 0 0 0 2 2v11M6 2v5M9 2v5M17 2c-1.5 1-2 3-2 6s.5 4 2 4v10',
    cafe: 'M4 8h12v5a5 5 0 0 1-5 5H9a5 5 0 0 1-5-5V8Zm12 1h2.5a2.5 2.5 0 0 1 0 5H16M4 21h13',
    bakery: 'M4 14c0-4 3.5-7 8-7s8 3 8 7-3.5 4-8 4-8 0-8-4Zm4-1 1.5-3M12 13l1.5-3M16 13l1.5-3',
    fast_food: 'M4 12a8 8 0 0 1 16 0H4Zm-1 4h18M5 20h14',
    food_court: 'M3 10h18l-2 9H5L3 10Zm5-4 4-3 4 3',
    hotel_restaurant: 'M4 20V6h16v14M4 11h16M9 6V3h6v3',
    // basket
    grocery: 'M3 8h18l-2 12H5L3 8Zm5 0 3-5m5 5-3-5M9 12v4m6-4v4',
    butcher: 'M7 3v8a4 4 0 0 0 8 0V3M11 15v6M8 21h6',
    // dome + crescent
    mosque: 'M12 3c3 2.5 5 5 5 7H7c0-2 2-4.5 5-7Zm-5 7v11h10V10M4 21h16M12 3V1',
    prayer_room: 'M12 4a3 3 0 1 0 0 .01M8 21c0-4 1.5-6 4-6s4 2 4 6M5 21h14',
    attraction_dining: 'M12 3v18M3 12h18M5.6 5.6l12.8 12.8M18.4 5.6 5.6 18.4',
};

export function TypeGlyph({ type, size = 20 }: { type: PlaceType; size?: number }) {
    return (
        <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor"
             strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d={PATHS[type]} />
        </svg>
    );
}

/** Raw SVG string, for Leaflet divIcons which take HTML rather than JSX. */
export const TYPE_GLYPH: Record<PlaceType, string> = Object.fromEntries(
    (Object.keys(PATHS) as PlaceType[]).map((t) => [
        t,
        `<svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="${PATHS[t]}"/></svg>`,
    ]),
) as Record<PlaceType, string>;
